export const AIRPORTS = [
  { code: 'ZRH', label: 'Zürich', value: 'Flughafen Zürich (ZRH)' },
  { code: 'BSL', label: 'Basel', value: 'Basel EuroAirport (BSL)' },
  { code: 'GVA', label: 'Genève', value: 'Geneva Airport (GVA)' },
];
